import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavLink,
  NavItem,
  Spinner,
  Table,
  Button,
  Input,
  // PaginationLink,
  // PaginationItem,
  // Pagination,
  Label,
  Badge,
} from "reactstrap"
import ButtonSpinner from "components/ButtonSpinner"
import Modal from "react-bootstrap/Modal"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
//Import Styles
import "./styles.scss"
//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as yearWiseEventsAction from "../../../store/ZXZlbnRXaXNlRGF0/actions"
import api from "helpers/Api"
import * as eventClientAction from "../../../store/bXl3b3Jrc3Bob3Rv/actions"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import Select from "react-select"

const EventWiseDataCopy = (props) => {
  const title = "Event Wise Data Copy"
  const { dispatch, searchBarStyle } = props

  //Year and month format
  const currentYear = moment().format("YYYY")
  const nextYear = moment().add(1, "years").format("YYYY")
  const prevYear = moment().subtract(1, "years").format("YYYY")

  const currentMonthDetails = moment().format("MM")
  const currentMonthList = moment().format("MMMM")

  const currentMonth =
    (!isEmpty(currentMonthList) && currentMonthList === "June") ||
      (!isEmpty(currentMonthList) && currentMonthList === "July")
      ? currentMonthList
      : currentMonthList.slice(0, 3)

  useEffect(() => {
    dispatch(
      yearWiseEventsAction.loadEventCompleteList({
        year: currentYear,
        month: currentMonthDetails
      })
    )
 
    dispatch(yearWiseEventsAction.loadRecordsMetaData())
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
    }, 5000)
  }, [])

  //Reducer store state maintenance
  const eventCompleteUpdate = useSelector((state) => state.eventWiseDataCopy)

  const { recordsMetaData = {},
    event_complete_details = []
  } =
    eventCompleteUpdate

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate
  console.log(recordsMetaData, "recordsMetaData")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //State maintenance section
  const [customIconActiveTab, setCustomIconActiveTab] = useState(currentMonth)
  const [customIconActiveYear, setCustomIconActiveYear] = useState(currentYear)
  const [monthDetails, setMonthDetails] = useState("")
  const [eventDate, setEventDate] = useState("")

  //const [serviceDetailsData, setServiceDetailsData] = useState([])
  //const [serviceDetailsDataSet, setServiceDetailsDataSet] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [btnLoader, setBtnLoader] = useState(false)
  const [pageSelected, setPageSelected] = useState(false)

  const [service, setService] = useState([])
  const [copyStatus, setCopyStatus] = useState([])
  const [flrName, setflrName] = useState([])
  //Reset fucntinalities

  const [eventToDate, setEventToDate] = useState("")

  const resetForm = () => {
    setEventDate("")
    setBtnLoading(true)
    setEvent([])
    setEventToDate("")
    setSearchValueList({})
    setCopyStatus([])
    setService([])
    setflrName([])
    api
      .post("/event_wise_data_copy_report", {
        year: currentYear,
        month: currentMonthDetails,
      })
      .then((res) => {
        console.log(res,"eventDataaa")
        const eventFilterDataTable = !isEmpty(res.data.data)
          ? res.data.data.result.map((eventData, index) => {
            // slNo = slNo + 1

                console.log(eventData,"eventDataaa")
            const eventDate =
              !isEmpty(eventData.eventDate) && eventData.eventDate
                ? moment(eventData.eventDate).format(dateFormate)
                : ""

            // if (
            //   !isEmpty(eventData) &&
            //   !isEmpty(eventData.serviceData) &&
            //   eventData.serviceData &&
            //   !serviceDetailsDataSet
            // ) {
            //   setServiceDetailsData(eventData.serviceData)
            //   setServiceDetailsDataSet(true)
            // }
            // console.log(service, "service")

            return {
              _id: eventData._id,
              sNo: index + 1,
              leadNo: eventData.leadNo,
              bride: eventData.brideName,
              clientCode: eventData.clientCode,
              groom: eventData.groomName,
              eventId: eventData.eventId,
              eventDate: eventDate,
              eventName: eventData.eventName,
              venue: eventData.venueName,
              location: eventData.location,
              branchName: eventData.branch,
              key: index,
              serviceData: eventData.serviceData
            }
          })
          : []
        setTimeout(() => {
          setEventDataTable(eventFilterDataTable)
          setBtnLoading(false)
        }, 2000)
        return res.data
      })
      .catch((error) => Promise.reject(error))


  }


  const eventDataTable = !isEmpty(event_complete_details)
    ? event_complete_details.map((eventData, index) => {

      const eventDate =
        !isEmpty(eventData.eventDate) && eventData.eventDate
          ? moment(eventData.eventDate).format(dateFormate)
          : ""

      // if (
      //   !isEmpty(eventData) &&
      //   !isEmpty(eventData.serviceData) &&
      //   eventData.serviceData &&
      //   !serviceDetailsDataSet
      // ) {
      //   setServiceDetailsData(eventData.serviceData)
      //   setServiceDetailsDataSet(true)
      // }
      // console.log(service, "service")

      return {
        _id: eventData._id,
        sNo: index + 1,
        leadNo: eventData.leadNo,
        bride: eventData.brideName,
        clientCode: eventData.clientCode,
        groom: eventData.groomName,
        eventId: eventData.eventId,
        eventDate: eventDate,
        eventName: eventData.eventName,
        venue: eventData.venueName,
        location: eventData.location,
        branchName: eventData.branch,
        key: index,
        serviceData: eventData.serviceData
      }
    })
    : []

  const [event, setEvent] = useState([])
  const events = !isEmpty(event) ? event.map(m => m.value) : []
  const services = !isEmpty(service) ? service.map(m => m.value) : []
  const flrValue =  !isEmpty(flrName) ? flrName.map(m => m.value) : []
  const serviceLevelValue =  !isEmpty(copyStatus) ? copyStatus.map(m => m.value) : []
  const applyFilter = (e) => {
    e.preventDefault()
    var searchEvent = !isEmpty(event) && event ? events : ""
    var searchEventDate = eventDate
      ? moment(eventDate).format("YYYY-MM-DD")
      : ""

    var searchEventDateYear = eventDate
      ? moment(eventDate).format("YYYY")
      : !isEmpty(monthDetails)
        ? monthDetails.year
        : currentYear
    var searchEventDateMonth = eventDate
      ? moment(eventDate).format("MM")
      : !isEmpty(monthDetails)
        ? monthDetails.value
        : currentMonthDetails

    var searchEventToDate = eventToDate
      ? moment(eventToDate).format("YYYY-MM-DD")
      : ""
    var searchService = !isEmpty(service) && service ? services : ""
    var searchServiceStatus = !isEmpty(copyStatus) && copyStatus ? serviceLevelValue : ""
    var searchFlr = !isEmpty(flrName) && flrName ? flrValue : ""
    var searchValue = {}
    if (searchService) {
      searchValue.serviceName = searchService
    }
    if (searchServiceStatus) {
      searchValue.serviceLevelStatusId= searchServiceStatus
    }
    if (searchFlr) {
      searchValue.freelancerIds = searchFlr
    }

    if (searchEvent) {
      searchValue.event = searchEvent
    }
    if (searchEventDate) {
      searchValue.eventFromDate = searchEventDate
    }

    if (searchEventToDate) {
      searchValue.eventToDate = searchEventToDate
    }
    if (searchEventDateYear) {
      searchValue.year = searchEventDateYear
    }
    if (searchEventDateMonth) {
      searchValue.month = searchEventDateMonth
    }

    setSearchValueList(searchValue)
    api
      .post("/event_wise_data_copy_report", searchValue)
      .then((res) => {


      
        const eventFilterDataTable =!isEmpty(res.data.data)
        ? res.data.data.result.map((eventData, index) => {
            // slNo = slNo + 1


            const eventDate =
              !isEmpty(eventData.eventDate) && eventData.eventDate
                ? moment(eventData.eventDate).format(dateFormate)
                : ""

            // if (
            //   !isEmpty(eventData) &&
            //   !isEmpty(eventData.serviceData) &&
            //   eventData.serviceData &&
            //   !serviceDetailsDataSet
            // ) {
            //   setServiceDetailsData(eventData.serviceData)
            //   setServiceDetailsDataSet(true)
            // }
            // console.log(service, "service")

            return {
              _id: eventData._id,
              sNo: index + 1,
              leadNo: eventData.leadNo,
              bride: eventData.brideName,
              clientCode: eventData.clientCode,
              groom: eventData.groomName,
              eventId: eventData.eventId,
              eventDate: eventDate,
              eventName: eventData.eventName,
              venue: eventData.venueName,
              location: eventData.location,
              branchName: eventData.branch,
              key: index,
              serviceData: eventData.serviceData
            }
          })
          : []
        setTimeout(() => {
          setEventDataTable(eventFilterDataTable)
        }, 2000)
        return res.data
      })
      .catch((error) => Promise.reject(error))


    setBtnLoading(true)
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 3000)
  }

  //Data table andsorting functionality

  const [eventsDataTable, setEventDataTable] = useState("")
  const [eventPageLoad, setEventPagePageLoad] = useState(false)

  if (!isEmpty(eventDataTable) && eventDataTable.length > 0 && !eventPageLoad) {
    setEventPagePageLoad(true)
    setEventDataTable(eventDataTable)
  }

  const [sortDirection, setSortDirection] = useState("asc")
  const handleDateSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = new Date(a.eventDate)
      const dateB = new Date(b.eventDate)
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }

  const handleLeadSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.leadNo
      const dateB = b.leadNo
      return sortDirection === "asc" ? dateA - dateB : dateB - dateA
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }

  const handleClientCodeSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.clientCode
      const dateB = b.clientCode

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleBrideSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.bride
      const dateB = b.bride

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleGroomSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.groom
      const dateB = b.groom
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }
  const handleEventSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.eventName
      const dateB = b.eventName
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }

  const handleVenueSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.venue
      const dateB = b.venue
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    // console.log(sortedData, "sortedData")
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }


  const handleLocationSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      const dateA = a.location
      const dateB = b.location
      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })
    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }

  const handleBranchSort = () => {
    const sortedData = [...eventsDataTable]
    sortedData.sort((a, b) => {
      // console.log(a, b, "name")
      const dateA = a.branchName
      const dateB = b.branchName

      if (sortDirection === "asc") {
        return dateA > dateB ? 1 : -1
      } else if (sortDirection === "desc") {
        return dateA > dateB ? -1 : 1
      }
    })

    setEventDataTable(sortedData)
    setSortDirection(sortDirection === "asc" ? "desc" : "asc")
  }



  let tabs = [
    { value: "06", label: "June", year: prevYear },
    { value: "07", label: "July", year: prevYear },
    { value: "08", label: "Aug", year: prevYear },
    { value: "09", label: "Sep", year: prevYear },
    { value: "10", label: "Oct", year: prevYear },
    { value: "11", label: "Nov", year: prevYear },
    { value: "12", label: "Dec", year: prevYear },
    { value: "01", label: "Jan", year: currentYear },
    { value: "02", label: "Feb", year: currentYear },
    { value: "03", label: "Mar", year: currentYear },
    { value: "04", label: "Apr", year: currentYear },
    { value: "05", label: "May", year: currentYear },
    { value: "06", label: "June", year: currentYear }

  ]

  const [tabSelected, setTabSelected] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [eventCompleteList, setEventCompleteList] = useState("")

  console.log(eventCompleteList, "eventCompleteList")
  // console.log(tabSelected, "tabSelected")

  useEffect(() => {
    if (tabSelected === true) {

      api
        .post("/event_wise_data_copy_report", {
          year: monthDetails.year,
          month: monthDetails.value,
      
        })
        .then((res) => {
          setTimeout(() => {

            const eventDataTable =
            !isEmpty(res.data.data)
            ? res.data.data.result.map((eventData, index) => {

                  const eventDate =
                    !isEmpty(eventData.eventDate) && eventData.eventDate
                      ? moment(eventData.eventDate).format(dateFormate)
                      : ""

                  // if (
                  //   !isEmpty(eventData) &&
                  //   !isEmpty(eventData.serviceData) &&
                  //   eventData.serviceData &&
                  //   !serviceDetailsDataSet
                  // ) {
                  //   setServiceDetailsData(eventData.serviceData)
                  //   setServiceDetailsDataSet(true)
                  // }


                  return {
                    _id: eventData._id,
                    sNo: index + 1,
                    leadNo: eventData.leadNo,
                    bride: eventData.brideName,
                    clientCode: eventData.clientCode,
                    groom: eventData.groomName,
                    eventId: eventData.eventId,
                    eventDate: eventDate,
                    eventName: eventData.eventName,
                    venue: eventData.venueName,
                    location: eventData.location,
                    branchName: eventData.branch,
                    key: index,
                    serviceData: eventData.serviceData
                  }
                })
                : []

            setEventDataTable(eventDataTable)
            setTabSelected(false)
          }, 4000)
          setEventCompleteList(res.data.data)
          res.data
        })
        .catch((error) => Promise.reject(error))

      setPageLoad(!pageLoad)
    }
  }, [tabSelected])


  //remote pagination section
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const exportToCsv = () => {
    var searchEvent = !isEmpty(event) ? event : ""
    var searchEventDate = eventDate
      ? moment(eventDate).format("YYYY-MM-DD")
      : ""
    var searchEventDateYear = eventDate
      ? moment(eventDate).format("YYYY")
      : !isEmpty(monthDetails)
        ? monthDetails.year
        : currentYear
    var searchEventDateMonth = eventDate
      ? moment(eventDate).format("MM")
      : !isEmpty(monthDetails)
        ? monthDetails.value
        : currentMonthDetails
    var searchEventToDate = eventToDate
      ? moment(eventToDate).format("YYYY-MM-DD")
      : ""
    var searchService = !isEmpty(service) && service ? services : ""
     var searchServiceStatus = !isEmpty(copyStatus) && copyStatus ? serviceLevelValue : ""
    var searchFlr = !isEmpty(flrName) && flrName ? flrValue : ""
    var searchValue = {}
    if (searchService) {
      searchValue.serviceName = searchService
    }
    if (searchServiceStatus) {
      searchValue.serviceLevelStatusId= searchServiceStatus
    }
    if (searchFlr) {
      searchValue.freelancerIds= searchFlr
    }
  
    if (searchEvent) {
      searchValue.event = searchEvent
    }
    if (searchEventDate) {
      searchValue.eventFromDate = searchEventDate
    }

    if (searchEventToDate) {
      searchValue.eventToDate = searchEventToDate
    }
    if (searchEventDateYear) {
      searchValue.year = searchEventDateYear
    }
    if (searchEventDateMonth) {
      searchValue.month = searchEventDateMonth
    }
    api
      .post(`event_wise_data_copy_report_excel_export`, searchValue)
      .then((response) => {
        const eventDataTableList =
          !isEmpty(response.data) && response.data.result
            ? response.data.result.map((eventData, index) => {
              const eventDate =
                eventData.eventDate
                  ? moment(eventData.eventDate).format(dateFormate)
                  : ""

              // Set service data if not already set


              return {
                _id: eventData._id,
                sNo: index + 1,
                leadNo: eventData.leadNo,
                bride: eventData.brideName,
                clientCode: eventData.clientCode,
                groom: eventData.groomName,
                eventId: eventData.eventId,
                eventDate,
                eventName: eventData.eventName,
                venue: eventData.venueName,
                location: eventData.location,
                branchName: eventData.branch,
                serviceData: eventData.serviceData,
              }
            }) : []



        setTimeout(() => {
          // Generate dynamic headers
          const dynamicHeaders = [
            "TRADITIONAL PHOTOGRAPHY",
            "TRADITIONAL VIDEOGRAPHY",
            "CANDID PHOTOGRAPHY",
            "CANDID VIDEOGRAPHY",
            "HELICAM",
            "MIXING UNIT",
            "LIVE STREAMING"
          ].map((serviceName) => `${serviceName},,,,,`)

          const dynamicHeadersData = [
            "TRADITIONAL PHOTOGRAPHY",
            "TRADITIONAL VIDEOGRAPHY",
            "CANDID PHOTOGRAPHY",
            "CANDID VIDEOGRAPHY",
            "HELICAM",
            "MIXING UNIT",
            "LIVE STREAMING"
          ].map((serviceName) => serviceName)

          const headersRow1 = [
            "SNo",
            "Lead No",
            "Client Code",
            "Bride Name",
            "Groom Name",
            "Event Date",
            "Event Name",
            "Venue",
            "Location",
            "Branch",
            ...dynamicHeaders,
          ]

          const subHeaders = [
            "teamShooterName",
            "serviceLevelStatus",
            "fileCount",
            "size",
            "remarks",
            "copiedDate",
          ]

          const headersRow2 = [
            ...Array(10).fill(""), // First 10 static columns
            ...dynamicHeaders.flatMap(() => subHeaders),
          ]

          const headerData = [
            headersRow1.join(","),
            headersRow2.join(","),
          ]

          const usersCsv = eventDataTableList.map((user) => {
            const {
              sNo,
              leadNo,
              clientCode,
              bride,
              groom,
              eventDate,
              eventName,
              venue,
              location,
              branchName,
              serviceData,
            } = user

            const serviceValues = dynamicHeadersData.flatMap((serviceName) =>
              serviceData?.[serviceName]
                ? [
                  JSON.stringify(serviceData[serviceName].teamShooterName.join(", ").replace(/,/g, "\n")),
                  JSON.stringify(serviceData[serviceName].serviceLevelStatus.join(", ").replace(/,/g, "\n")),
                  JSON.stringify(serviceData[serviceName].fileCount.join(", ").replace(/,/g, "\n")),
                  JSON.stringify(serviceData[serviceName].size.join(", ").replace(/,/g, "\n")),
                  JSON.stringify(serviceData[serviceName].remarks.join(", ").replace(/,/g, "\n")),
                  JSON.stringify(serviceData[serviceName].copiedDate.join(", ").replace(/,/g, "\n")),
                ]
                : Array(6).fill("--")
            )

            return [
              sNo,
              leadNo,
              clientCode,
              bride,
              groom,
              eventDate,
              eventName,
              venue,
              location,
              branchName,
              ...serviceValues,
            ].join(",")
          })

          const csvData = [...headerData, ...usersCsv].join("\n")

          downloadFile({
            data: csvData,
            fileName: "EventWiseDataCopy.csv",
            fileType: "text/csv",
          })

          setBtnLoading(false)
        }, 3500)
      })
      .catch((error) => Promise.reject(error))
  }
  // const exportToCsv = () => {
  //   var searchEvent = !isEmpty(event) ? event : ""
  //   var searchEventDate = eventDate
  //     ? moment(eventDate).format("YYYY-MM-DD")
  //     : ""
  //   var searchEventDateYear = eventDate
  //     ? moment(eventDate).format("YYYY")
  //     : !isEmpty(monthDetails)
  //       ? monthDetails.year
  //       : currentYear
  //   var searchEventDateMonth = eventDate
  //     ? moment(eventDate).format("MM")
  //     : !isEmpty(monthDetails)
  //       ? monthDetails.value
  //       : currentMonthDetails
  //   var searchEventToDate = eventToDate
  //     ? moment(eventToDate).format("YYYY-MM-DD")
  //     : ""
  //   var searchValue = {}
  //   searchValue.page = 1
  //   searchValue.limit = 100
  //   if (searchEvent) {
  //     searchValue.event = searchEvent
  //   }
  //   if (searchEventDate) {
  //     searchValue.eventFromDate = searchEventDate
  //   }

  //   if (searchEventToDate) {
  //     searchValue.eventToDate = searchEventToDate
  //   }
  //   if (searchEventDateYear) {
  //     searchValue.year = searchEventDateYear
  //   }
  //   if (searchEventDateMonth) {
  //     searchValue.month = searchEventDateMonth
  //   }
  //   api
  //     .post(`event_wise_data_copy_report_excel_export`, searchValue)
  //     .then((response) => {
  //       const eventDataTableList =
  //         !isEmpty(response.data) && response.data.data
  //           ? response.data.data.map((eventData, index) => {
  //             const eventDate =
  //               eventData.eventDate
  //                 ? moment(eventData.eventDate).format(dateFormate)
  //                 : ""

  //             // Set service data if not already set
  //             // if (
  //             //   !isEmpty(eventData.serviceData) &&
  //             //   !serviceDetailsDataSet
  //             // ) {
  //             //   setServiceDetailsData(eventData.serviceData)
  //             //   setServiceDetailsDataSet(true)
  //             // }

  //             return {
  //               _id: eventData._id,
  //               sNo: index + 1,
  //               leadNo: eventData.leadNo,
  //               bride: eventData.brideName,
  //               clientCode: eventData.clientCode,
  //               groom: eventData.groomName,
  //               eventId: eventData.eventId,
  //               eventDate,
  //               eventName: eventData.eventName,
  //               venue: eventData.venueName,
  //               location: eventData.location,
  //               branchName: eventData.branch,
  //               serviceData: eventData.serviceData,
  //             }
  //           }) : []



  //       setTimeout(() => {
  //         // Generate dynamic headers
  //         const dynamicHeaders = [
  //           "TRADITIONAL PHOTOGRAPHY","","","","","",
  //           "TRADITIONAL VIDEOGRAPHY","","","","","",
  //           "CANDID PHOTOGRAPHY","","","","","",
  //           "CANDID VIDEOGRAPHY","","","","","",
  //           "HELICAM","","","","","",
  //           "MIXING UNIT","","","","","",
  //           "LIVE STREAMING"
  //         ]
  //         const dynamicHeadersData =  [
  //           "TRADITIONAL PHOTOGRAPHY",
  //           "TRADITIONAL VIDEOGRAPHY",
  //           "CANDID PHOTOGRAPHY",
  //           "CANDID VIDEOGRAPHY",
  //           "HELICAM",
  //           "MIXING UNIT",
  //           "LIVE STREAMING"
  //         ]
  //         const headersRow1 = [
  //           "SNo",
  //           "Lead No",
  //           "Client Code",
  //           "Bride Name",
  //           "Groom Name",
  //           "Event Date",
  //           "Event Name",
  //           "Venue",
  //           "Location",
  //           "Branch",
  //           ...dynamicHeaders,
  //         ]

  //         const subHeaders = [
  //           "teamShooterName",
  //           "serviceLevelStatus",
  //           "fileCount",
  //           "size",
  //           "remarks",
  //           "copiedDate",
  //         ]

  //         const headersRow2 = [
  //           ...Array(10).fill(""), // First 10 static columns
  //           ...dynamicHeadersData.flatMap(() => subHeaders),
  //         ]

  //         const headerData = [
  //           headersRow1.join(","),
  //           headersRow2.join(","),
  //         ]

  //         const usersCsv = eventDataTableList.map((user) => {
  //           const {
  //             sNo,
  //             leadNo,
  //             clientCode,
  //             bride,
  //             groom,
  //             eventDate,
  //             eventName,
  //             venue,
  //             location,
  //             branchName,
  //             serviceData,
  //           } = user

  //           const serviceValues = dynamicHeadersData.flatMap((serviceName) =>
  //             serviceData?.[serviceName]
  //               ? [
  //                 serviceData[serviceName].teamShooterName.join(","),
  //                 serviceData[serviceName].serviceLevelStatus.join(" "),
  //                 serviceData[serviceName].fileCount.join(" "),
  //                 serviceData[serviceName].size.join(" "),
  //                 serviceData[serviceName].remarks.join(" "),
  //                 serviceData[serviceName].copiedDate.join(" "),
  //               ]
  //               : Array(6).fill("-")
  //           )

  //           return [
  //             sNo,
  //             leadNo,
  //             clientCode,
  //             bride,
  //             groom,
  //             eventDate,
  //             eventName,
  //             venue,
  //             location,
  //             branchName,
  //             ...serviceValues,
  //           ].join(",")
  //         })

  //         const csvData = [...headerData, ...usersCsv].join("\n")

  //         downloadFile({
  //           data: csvData,
  //           fileName: "EventWiseDataCopy.csv",
  //           fileType: "text/csv",
  //         })

  //         setBtnLoading(false)
  //       }, 3500)
  //     })
  //     .catch((error) => Promise.reject(error))
  // }

  // const exportToCsv = () => {
  //   var searchEvent = !isEmpty(event) && event ? events : ""
  //   var searchEventDate = eventDate
  //     ? moment(eventDate).format("YYYY-MM-DD")
  //     : ""

  //   var searchEventDateYear = eventDate
  //     ? moment(eventDate).format("YYYY")
  //     : !isEmpty(monthDetails)
  //       ? monthDetails.year
  //       : currentYear
  //   var searchEventDateMonth = eventDate
  //     ? moment(eventDate).format("MM")
  //     : !isEmpty(monthDetails)
  //       ? monthDetails.value
  //       : currentMonthDetails

  //   var searchEventToDate = eventToDate
  //     ? moment(eventToDate).format("YYYY-MM-DD")
  //     : ""

  //   var searchValue = {}
  //   searchValue.page = 1
  //   searchValue.limit = 100
  //   if (searchEvent) {
  //     searchValue.event = searchEvent
  //   }
  //   if (searchEventDate) {
  //     searchValue.eventFromDate = searchEventDate
  //   }

  //   if (searchEventToDate) {
  //     searchValue.eventToDate = searchEventToDate
  //   }
  //   if (searchEventDateYear) {
  //     searchValue.year = searchEventDateYear
  //   }
  //   if (searchEventDateMonth) {
  //     searchValue.month = searchEventDateMonth
  //   }
  //   api
  //     .post(`event_wise_data_copy_report_excel_export`, searchValue)
  //     .then((response) => {
  //       const eventDataTableList =
  //         !isEmpty(response.data) && response.data.data
  //           ? response.data.data.data.map((eventData, index) => {


  //             const eventDate =
  //                   !isEmpty(eventData.eventDate) && eventData.eventDate
  //                     ? moment(eventData.eventDate).format(dateFormate)
  //                     : ""

  //                 if (
  //                   !isEmpty(eventData) &&
  //                   !isEmpty(eventData.serviceData) &&
  //                   eventData.serviceData &&
  //                   !serviceDetailsDataSet
  //                 ) {
  //                   setServiceDetailsData(eventData.serviceData)
  //                   setServiceDetailsDataSet(true)
  //                 }


  //                 return {
  //                   _id: eventData._id,
  //                   sNo: index + 1,
  //                   leadNo: eventData.leadNo,
  //                   bride: eventData.brideName,
  //                   clientCode: eventData.clientCode,
  //                   groom: eventData.groomName,
  //                   eventId: eventData.eventId,
  //                   eventDate: eventDate,
  //                   eventName: eventData.eventName,
  //                   venue: eventData.venueName,
  //                   location: eventData.location,
  //                   branchName: eventData.branch,
  //                   key: index,
  //                   serviceData: eventData.serviceData
  //                 }
  //               })
  //               : []
  //       // console.log(eventDataTableList, "eventDataTableList")
  //       setBtnLoading(true)

  //       setTimeout(() => {
  //         let headerData = [
  //           `SNo,Lead No,Client Code, Bride Name,Groom Name, Event Date,Event Name, Venue, Location, Company, Branch, ${!isEmpty(serviceDetailsData)
  //             ? serviceDetailsData.map((value) => value.serviceName).join(",")
  //             : ""
  //           }`,
  //         ]

  //         let usersCsv =
  //           !isEmpty(eventDataTableList) &&
  //           eventDataTableList.reduce((acc, user) => {
  //             const {
  //               sNo,
  //               leadNo,
  //               clientCode,
  //               bride,
  //               groom,
  //               eventDate,
  //               eventName,
  //               venue,
  //               location,
  //               branchName
  //             } = user
  //             acc.push([
  //               sNo,
  //               leadNo,
  //               clientCode,
  //               bride,
  //               groom,
  //               eventDate,
  //               eventName,
  //               venue,
  //               location,
  //               branchName
  //             ])


  //             return acc
  //           }, [])

  //         const userDetails =
  //           !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []
  //         downloadFile({
  //           data: [...headerData, ...userDetails].join("\n"),
  //           fileName: "EventWiseDataCopy.csv",
  //           fileType: "text/csv",
  //         })
  //         // setDownloadLoading(false)
  //         setBtnLoading(false)
  //       }, 3500)
  //       return response.data
  //     })
  //     .catch((error) => Promise.reject(error))
  // }

  //Search bar functionality
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  // const [pageFreelancerLoad, setPageFreelancerLoad] = useState(false)
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
        
          year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
          month: !isEmpty(monthDetails)
            ? monthDetails.value
            : currentMonthDetails,
        }
        : {
          year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
          month: !isEmpty(monthDetails)
            ? monthDetails.value
            : currentMonthDetails,
          searchFilter: searchInput,
        
        }




  // console.log(searchInput, "searchInput")
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    setBtnLoading(true)

    // setTimeout(() => {
    // dispatch(yearWiseEventsAction.loadEventCompleteList(searchValue ))
    api.post("event_wise_data_copy_report", searchValue).then((res) => {
      setTimeout(() => {

        const eventDataTable =
        !isEmpty(res.data.result) && res.data.result.length > 0
        ? res.data.result.map((eventData, index) => {

              const eventDate =
                !isEmpty(eventData.eventDate) && eventData.eventDate
                  ? moment(eventData.eventDate).format(dateFormate)
                  : ""

              // if (
              //   !isEmpty(eventData) &&
              //   !isEmpty(eventData.serviceData) &&
              //   eventData.serviceData &&
              //   !serviceDetailsDataSet
              // ) {
              //   setServiceDetailsData(eventData.serviceData)
              //   setServiceDetailsDataSet(true)
              // }
              // console.log(service, "service")

              return {
                _id: eventData._id,
                sNo: index + 1,
                leadNo: eventData.leadNo,
                bride: eventData.brideName,
                clientCode: eventData.clientCode,
                groom: eventData.groomName,
                eventId: eventData.eventId,
                eventDate: eventDate,
                eventName: eventData.eventName,
                venue: eventData.venueName,
                location: eventData.location,
                branchName: eventData.branch,
                key: index,
                serviceData: eventData.serviceData
              }
            })
            : []
        setEventDataTable(eventDataTable)
        setBtnLoading(false)
      }, 3500)
      setTimeout(() => {
        setSearchFilter(false)
      }, 1200)
      res.data
    })
    // }, 1000)
  }

  //Page selection load

  useEffect(() => {
    if (pageSelected === true) {
      dispatch(
        yearWiseEventsAction.loadEventCompleteList({
          year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
          month: !isEmpty(monthDetails)
            ? monthDetails.value
            : currentMonthDetails,
       
        })
      )
      api
        .post("/event_wise_data_copy_report", {
          year: !isEmpty(monthDetails) ? monthDetails.year : currentYear,
          month: !isEmpty(monthDetails)
            ? monthDetails.value
            : currentMonthDetails,
       
        })
        .then((res) => {
          setTimeout(() => {

            const eventDataTable =
            !isEmpty(res.data.data)
            ? res.data.data.result.map((eventData, index) => {

                  const eventDate =
                    !isEmpty(eventData.eventDate) && eventData.eventDate
                      ? moment(eventData.eventDate).format(dateFormate)
                      : ""

                  // if (
                  //   !isEmpty(eventData) &&
                  //   !isEmpty(eventData.serviceData) &&
                  //   eventData.serviceData &&
                  //   !serviceDetailsDataSet
                  // ) {
                  //   setServiceDetailsData(eventData.serviceData)
                  //   setServiceDetailsDataSet(true)
                  // }
                  // console.log(service, "service")

                  return {
                    _id: eventData._id,
                    sNo: index + 1,
                    leadNo: eventData.leadNo,
                    bride: eventData.brideName,
                    clientCode: eventData.clientCode,
                    groom: eventData.groomName,
                    eventId: eventData.eventId,
                    eventDate: eventDate,
                    eventName: eventData.eventName,
                    venue: eventData.venueName,
                    location: eventData.location,
                    branchName: eventData.branch,
                    key: index,
                    serviceData: eventData.serviceData
                  }
                })
                : []
            setEventDataTable(eventDataTable)
          }, 4000)
          setEventCompleteList(res.data.data)
          res.data
        })
        .catch((error) => Promise.reject(error))
      setTimeout(() => {
        setBtnLoading(false)
        setPageSelected(false)
      }, 5000)
    }
  }, [pageSelected])


  const clientEventUpdate = useSelector(
    (specificstate) => specificstate.myWorksCompleted
  )
  const { clientEvent_data = [] } = clientEventUpdate

  const [clientEventModal, setClientEventModal] = useState(false)
  const loadClientEvent = (payload) => {
    setClientEventModal(true)
    const payloadData = {
      clientNo: payload,
    }
    setTimeout(() => {
      dispatch(eventClientAction.loadClientEvent(payloadData))
    })
  }

  //Data Table section
  const clientDataTable = !isEmpty(clientEvent_data)
    ? clientEvent_data.map((data, index) => {
      //////////////
      const eventName = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventName).join(",")
        : "--"
      const eventNo = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventNo).join(",")
        : "--"
      const eventDate = !isEmpty(data.eventDetails)
        ? data.eventDetails
          .map((m) => moment(m.eventDate).format(dateFormate))
          .join(",")
        : "--"
      const startTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.startTime).join(",")
        : "--"
      const endTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.endTime).join(",")
        : "--"
      const venue = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.venueLocation).join(",")
        : "--"
      return {
        index: index,
        key: index,
        leadId: data.leadId,
        leadNo: data.leadNo,
        sNo: index + 1,
        serviceCount: !isEmpty(data.serviceDetails)
          ? data.serviceDetails.length
          : 0,
        isCommit: data.isCommit,
        eventName: eventName,
        eventNo: eventNo,
        eventDate: eventDate,
        startTime: startTime,
        endTime: endTime,
        venueLocation: venue,
        serviceDetails: data.serviceDetails,
      }
    })
    : []

  //table columns
  const clientColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      csvExport: false,
      hidden: false,
      formatter: (cellContent, row) => {
        return <span>{row.leadNo}</span>
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "serviceCount",
      text: "Services",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.serviceCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const clientExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Shooter
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                File Count
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Size
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              !isEmpty(row.serviceDetails) &&
              row.serviceDetails.length > 0 ? (
              row.serviceDetails.map((data, index) => {
                const serviceName = !isEmpty(data.serviceId)
                  ? data.serviceId.serviceName
                  : "--"
                const freelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceMainShooterName
                    )
                    : []

                const freelancerName =
                  !isEmpty(freelancer) && freelancer.length > 0
                    ? freelancer.join(",")
                    : "--"

                const subFreelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceSubShooterName
                    )
                    : []

                const subFreelancerName =
                  !isEmpty(subFreelancer) && subFreelancer.length > 0
                    ? subFreelancer.join(",")
                    : "--"

                const shooterName = !isEmpty(data.teamEmployeeShooterId)
                  ? data.teamEmployeeShooterId.empCode +
                  "-" +
                  data.teamEmployeeShooterId.name
                  : "--"
                return (
                  <tr key={index}>
                    <td>{data.serviceNo ? data.serviceNo : "--"}</td>
                    <td>{serviceName}</td>
                    <td>{shooterName}</td>
                    <td>{freelancerName}</td>
                    <td>{subFreelancerName}</td>
                    <td>
                      {data.serviceLevelStatusName
                        ? data.serviceLevelStatusName
                        : "--"}
                    </td>
                    <td>{data.fileCount ? data.fileCount : "--"}</td>
                    <td>{data.size ? data.size : "--"}</td>
                    <td>{data.remarks ? data.remarks : "--"}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={8}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),

    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  // pagination options
  const clientOptions = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col md="3" lg="3" xl="3" className="mt-3">
                      <Label className="form-label" htmlFor={"Event From Date"}>
                        {"Event From Date"}
                      </Label>
                      <Input
                        type="date"
                        name="eventDate"
                        value={eventDate}
                        onChange={(e) => setEventDate(e.target.value)}
                        className="form-control"
                      />
                    </Col>{" "}

                    <Col md="3" lg="3" xl="3" className="mt-3">
                      <Label className="form-label" htmlFor={"Event From Date"}>
                        {"Event To Date"}
                      </Label>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={eventToDate}
                        onChange={(e) => setEventToDate(e.target.value)}
                        className="form-control"
                      />
                    </Col>{" "}
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="form-label" htmlFor={"Event From Date"}>
                        {"Event"}
                      </Label>
                      <Select
                        type="text"
                        name="event"
                        value={event}
                        isMulti
                        onChange={(e) => setEvent(e)}
                        options={
                          recordsMetaData ? recordsMetaData.eventOptions : []
                        }
                        placeholder="Select Event"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Service"}</Label>
                      </div>
                      <Select

                        type="text"
                        name="service"
                        value={service}
                         isMulti
                        onChange={(e) => setService(e)}
                        options={[
                          { label: "TRADITIONAL PHOTOGRAPHY", value: "TRADITIONAL_PHOTOGRAPHY" },
                          { label: "CANDID PHOTOGRAPHY", value: "CANDID_PHOTOGRAPHY" },
                          { label: "TRADITIONAL VIDEOGRAPHY", value: "TRADITIONAL_VIDEOGRAPHY" },
                          { label: "CINEMATOGRAPHY", value: "CINEMATOGRAPHY" },
                          { label: "HELICAM", value: "HELICAM" },
                          { label: "MIXING UNIT", value: "MIXING_UNIT" },
                          { label: "LIVE STREAMING", value: "LIVE_STREAMING" }
                        ]}
                        placeholder="Select Service"
                        classNamePrefix="select2-selection"
                        isClearable
                        styles={{
                          menu: (provided) => ({ ...provided, zIndex: 9999 }), // Ensures the dropdown appears above other elements
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }) // Ensures portal mode dropdown is also high z-index
                        }}
                        menuPortalTarget={document.body}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Service Status"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="copyStatus"
                        value={copyStatus}
                         isMulti
                        onChange={(e) => setCopyStatus(e)}
                        options={
                          recordsMetaData ? recordsMetaData.copyStatusOptions : []
                        }
                        placeholder="Select Copy Status"
                        classNamePrefix="select2-selection"
                        isClearable
                        styles={{
                          menu: (provided) => ({ ...provided, zIndex: 9999 }), // Ensures the dropdown appears above other elements
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }) // Ensures portal mode dropdown is also high z-index
                        }}
                        menuPortalTarget={document.body}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Flr Name"}</Label>
                      </div>
                      <Select
                        isClearable={true}
                        type="text"
                        name="flrName"
                        value={flrName}
                         isMulti
                        onChange={(e) => setflrName(e)}
                        options={
                          recordsMetaData ? recordsMetaData.flrOptions : []
                        }
                        placeholder="Select Flr Name"
                        classNamePrefix="select2-selection"
                        styles={{
                          menu: (provided) => ({ ...provided, zIndex: 9999 }), // Ensures the dropdown appears above other elements
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }) // Ensures portal mode dropdown is also high z-index
                        }}
                        menuPortalTarget={document.body}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col lg="12" md="12" sm="12" xs="12">
                      <div
                        className="d-flex flex-row"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => resetForm()}
                          className="btn btn-danger btn-label simple-form-Reset-btn"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => applyFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md="12" lg="12" xl="12">
                      <div
                        className="d-flex flex-row"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                          <form
                            onSubmit={handleClick}
                            className="d-flex flex-row"
                          >
                            <div style={searchBarStyle || null}>
                              <Input
                                type="text"
                                name="searchInput"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                className="form-control"
                                placeholder="Search"
                                style={{ position: "relative" }}
                              />
                              <i
                                className="bx bx-search-alt"
                                style={{
                                  position: "absolute",
                                  top: "33px",
                                  left: "35px",
                                  fontSize: "13px",
                                }}
                              />
                            </div>
                            <button
                              className="btn btn-success mx-2"
                              type="submit"
                              style={{
                                background: searchFilter ? "#2ca67a" : "",
                                color: searchFilter ? "#ffffff" : "",
                              }}
                            // onClick={(e) => handleClick()}
                            >
                              <i className="fas fa-search"></i>
                            </button>
                          </form>
                        </div>
                      </div>{" "}
                      <div style={{ marginBottom: "20px", marginTop: "-44px" }}>
                        <Button
                          className="border float-right mx-10"
                          style={{
                            float: "right",
                            backgroundColor: "#e40d8c",
                            color: "#ffffff",
                          }}
                          onClick={exportToCsv}
                        >
                          Download{" "}
                        </Button>{" "}
                      </div>
                    </Col>
                    <Col md="12" lg="12" xl="12" className="mt-3">
                      <Nav
                        className="nav-tabs-custom nav-justified mb-3"
                      // style={{ marginBottom: "-1px" }}
                      >
                        {tabs.map((tab, tabIndex) => {
                          return (
                            <NavItem key={tabIndex}>
                              <NavLink
                                style={
                                  (customIconActiveTab === tab.label &&
                                    tab.year == prevYear &&
                                    tab.year == customIconActiveYear) ||
                                    (customIconActiveTab === tab.label &&
                                      tab.year == currentYear &&
                                      tab.year == customIconActiveYear) ||
                                    (customIconActiveTab === tab.label &&
                                      tab.year == nextYear &&
                                      tab.year == customIconActiveYear)
                                    ? {
                                      cursor: "pointer",
                                      color: "#000000",
                                      fontWeight: 600,
                                      backgroundColor: "#ffffff",
                                      borderRight:
                                        tab.label === "Dec"
                                          ? ""
                                          : "1px solid #c7c7c7",
                                      borderLeft:
                                        tab.label === "Jan"
                                          ? ""
                                          : "1px solid #c7c7c7",
                                    }
                                    : {
                                      cursor: "pointer",
                                      color: "#ad9f9f",
                                      fontWeight: 600,
                                      backgroundColor: "#f7f7f7",
                                      borderBottom: "1px solid #c7c7c7",
                                    }
                                }
                                onClick={() => {
                                  setMonthDetails(tab)
                                  setTabSelected(true)
                                  setCustomIconActiveTab(tab.label)
                                  setCustomIconActiveYear(tab.year)
                                  setBtnLoading(true)
                                  setTimeout(() => {
                                    setBtnLoading(false)
                                    setTabSelected(false)
                                  }, 5000)
                                }}
                              >
                                <span className="tabs-content d-none d-sm-block">
                                  {tab.label}
                                  {"-" + tab.year}
                                </span>
                              </NavLink>
                            </NavItem>
                          )
                        })}
                      </Nav>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" lg="12" xl="12">
                      <Table responsive bordered onScroll={true}>
                        <thead className="header-class">
                          <tr>
                            <th rowSpan={2}
                              style={{
                                verticalAlign: "middle",
                                position: "sticky",
                                top: 0,
                                left: 0,
                                zIndex: 2,
                                minWidth: "50px",
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            >
                              S.No
                            </th>
                            <th rowSpan={2}
                              style={{
                                verticalAlign: "middle",
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                                position: "sticky",
                                top: 0,
                                left: "50px",
                                zIndex: 2,
                                minWidth: "150px",
                              }}
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleLeadSort()}
                              >
                                <p>Lead No</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th rowSpan={2}
                              style={{
                                minWidth: "140px",
                                verticalAlign: "middle",
                                position: "sticky",
                                top: 0,
                                left: "200px",//djust based on combined widths of previous columns
                                zIndex: 2,
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleClientCodeSort()}
                              >
                                <p>Client Code</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>

                            <th rowSpan={2}
                              style={{
                                minWidth: "140px",
                                verticalAlign: "middle",
                                position: "sticky",
                                top: 0,
                                left: "340px", // Adjust based on combined widths
                                zIndex: 2,
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBrideSort()}
                              >
                                <p>Bride Name</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th rowSpan={2}
                              style={{
                                minWidth: "140px",
                                verticalAlign: "middle",
                                position: "sticky",
                                top: 0,
                                left: "480px", // Adjust based on combined widths
                                zIndex: 2,
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleGroomSort()}
                              >
                                <p>Groom Name</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th rowSpan={2}
                              style={{
                                minWidth: "120px",
                                verticalAlign: "middle",
                                position: "sticky",
                                top: 0,
                                left: "620px", // Adjust based on combined widths
                                zIndex: 2,
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleDateSort()}
                              >
                                <p>Event Date</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            <th rowSpan={2}
                              style={{
                                minWidth: "140px",
                                verticalAlign: "middle",
                                position: "sticky",
                                top: 0,
                                left: "740px", // Adjust based on combined widths
                                zIndex: 2,
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleEventSort()}
                              >
                                <p>Event Name</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>

                            <th rowSpan={2}
                              style={{
                                minWidth: "120px",
                                verticalAlign: "middle",
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleVenueSort()}
                              >
                                <p>Venue</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>

                            <th rowSpan={2}
                              style={{
                                minWidth: "100px",
                                verticalAlign: "middle",
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleLocationSort()}
                              >
                                <p>Location</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>

                            <th rowSpan={2}
                              style={{
                                minWidth: "100px",
                                verticalAlign: "middle",
                                borderRight: "1px solid #e1e1e1",
                                borderBottom: "1px solid #e1e1e1",
                              }}
                            // className="fixed-header"
                            >
                              <div
                                style={{ marginBottom: "-15px" }}
                                className="d-flex flex-row justify-content-between"
                                onClick={() => handleBranchSort()}
                              >
                                <p>Branch</p>
                                <p>
                                  {sortDirection === "asc" ? (
                                    <span className="sorting-icon">
                                      &#9650;
                                    </span> // Up arrow symbol
                                  ) : (
                                    <span className="sorting-icon">
                                      &#9660;
                                    </span> // Down arrow symbol
                                  )}
                                </p>
                              </div>
                            </th>
                            {["TRADITIONAL PHOTOGRAPHY",
                              "TRADITIONAL VIDEOGRAPHY",
                              "CANDID PHOTOGRAPHY",
                              "CANDID VIDEOGRAPHY",
                              "HELICAM",
                              "MIXING UNIT",
                              "LIVE STREAMING"].map((key) => (
                                <th
                                  colSpan={6} // Spanning 6 sub-columns
                                  style={{
                                    minWidth: "140px",
                                    textAlign: "center",
                                    borderRight: "1px solid #e1e1e1",
                                    borderBottom: "1px solid #e1e1e1",
                                  }}
                                  key={key}
                                >
                                  {key}
                                </th>
                              ))}


                          </tr>
                          <tr>
                            {/* {<th   colSpan={10}></th>} */}
                            {["TRADITIONAL PHOTOGRAPHY",
                              "TRADITIONAL VIDEOGRAPHY",
                              "CANDID PHOTOGRAPHY",
                              "CANDID VIDEOGRAPHY",
                              "HELICAM",
                              "MIXING UNIT",
                              "LIVE STREAMING"].map((key) =>
                                ["Team Name", "Service Status", "File Count", "Size", "Remarks", "Copied Date"].map((subHeader, index) => (
                                  <th
                                    style={{
                                      minWidth: "140px",
                                      textAlign: "center",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                    }}
                                    key={`${key}-${index}`}
                                  >
                                    {subHeader}
                                  </th>
                                ))
                              )}
                          </tr>
                        </thead>
                        <tbody>
                          {!isEmpty(eventsDataTable) &&
                            eventsDataTable.length > 0 ? (
                            eventsDataTable.map((data, index) => {
                              return (
                                <tr key={index} className="font-size-10">
                                  <td
                                    style={{
                                      position: "sticky",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      minWidth: "50px",
                                      top: 0,
                                      left: 0,
                                      zIndex: 2,
                                    }}
                                  >
                                    {data.sNo}
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      top: 0,
                                      left: "50px",
                                      zIndex: 2,
                                      minWidth: "150px",
                                    }}
                                  >
                                    {!isEmpty(data.leadNo) ? data.leadNo : "--"}
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      top: 0,
                                      left: "200px", // Adjust based on combined widths of previous columns
                                      zIndex: 2,
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      color: "#e40d8c",

                                    }}
                                  >
                                    <a
                                      onClick={() =>
                                        loadClientEvent(data.clientCode)
                                      }
                                    >
                                      {!isEmpty(data.clientCode)
                                        ? data.clientCode
                                        : ""}
                                    </a>
                                  </td>

                                  <td
                                    style={{
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      position: "sticky",
                                      top: 0,
                                      left: "340px", // Adjust based on combined widths
                                      zIndex: 2,
                                    }}
                                  >
                                    {!isEmpty(data.bride) ? data.bride : "--"}
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      position: "sticky",
                                      top: 0,
                                      left: "480px", // Adjust based on combined widths
                                      zIndex: 2,
                                    }}
                                  >
                                    {!isEmpty(data.groom) ? data.groom : "--"}
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      position: "sticky",
                                      top: 0,
                                      left: "620px", // Adjust based on combined widths
                                      zIndex: 2,
                                    }}
                                  >
                                    {data.eventDate}
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      position: "sticky",
                                      top: 0,
                                      left: "740px", // Adjust based on combined widths
                                      zIndex: 2,
                                    }}
                                  >
                                    {data.eventName}
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {data.venue}
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",

                                    }}
                                  >
                                    {data.location}
                                  </td>
                                  <td
                                    style={{

                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                    }}
                                  >
                                    {data.branchName}
                                  </td>


                                  {/* {!isEmpty(data.serviceData) &&
                                    Object.keys(data.serviceData).map((serviceKey) => (
                                      <>

                                        {["teamShooterName", "serviceLevelStatus", "fileCount", "size", "remarks", "copiedDate"].map((field, index) => (
                                          <td
                                            style={{
                                              textAlign: "center",
                                              borderRight: "1px solid #e1e1e1",
                                              minWidth: "140px",
                                            }}
                                            key={`${serviceKey}-${field}-${index}`}
                                          >
                                            {field === "fileCount" && data.serviceData[serviceKey][field]?.length > 0
                                              ? data.serviceData[serviceKey][field].join(" / ")
                                              : field === "copiedDate" && data.serviceData[serviceKey][field]?.length > 0
                                                ? data.serviceData[serviceKey][field]
                                                  .filter((date) => date)
                                                  .map((date) => moment(date).format(dateFormate))
                                                  .join(", ")
                                                : data.serviceData[serviceKey][field]?.length > 0
                                                  ? data.serviceData[serviceKey][field].join(", ")
                                                  : "--"}
                                          </td>
                                        ))}
                                      </>
                                    ))} */}
                                  {/* {!isEmpty(data.serviceData) ? (
                                    Object.keys(data.serviceData).map((serviceKey) => (
                                      <>
                                        {["teamShooterName", "serviceLevelStatus", "fileCount", "size", "remarks", "copiedDate"].map((field, index) => (
                                          <td
                                            style={{
                                              textAlign: "center",
                                              borderRight: "1px solid #e1e1e1",
                                              minWidth: "140px",
                                            }}
                                            key={`${serviceKey}-${field}-${index}`}
                                          >
                                            {field === "fileCount" && data.serviceData[serviceKey][field]?.length > 0
                                              ? data.serviceData[serviceKey][field].join(" / ")
                                              : field === "copiedDate" && data.serviceData[serviceKey][field]?.length > 0
                                                ? data.serviceData[serviceKey][field]
                                                  .filter((date) => date)
                                                  .map((date) => moment(date).format(dateFormate))
                                                  .join(", ")
                                                : data.serviceData[serviceKey][field]?.length > 0
                                                  ? data.serviceData[serviceKey][field].join(", ")
                                                  : "--"}
                                          </td>
                                        ))}
                                      </>
                                    ))
                                  ) :(
                                    ["TRADITIONAL PHOTOGRAPHY",
                                      "TRADITIONAL VIDEOGRAPHY",
                                      "CANDID PHOTOGRAPHY",
                                      "CANDID VIDEOGRAPHY",
                                      "HELICAM",
                                      "MIXING UNIT",
                                      "LIVE STREAMING"].map((serviceKey) => (
                                      <>
                                        {["teamShooterName", "serviceLevelStatus", "fileCount", "size", "remarks", "copiedDate"].map((field, index) => (
                                          <td
                                            style={{
                                              textAlign: "center",
                                              borderRight: "1px solid #e1e1e1",
                                              minWidth: "140px",
                                            }}
                                            key={`${serviceKey}-${field}-${index}`}
                                          >
                                            { "--"}
                                          </td>
                                        ))}
                                      </>
                                    ))
                                  ) } */}
                                  {[
                                    "TRADITIONAL PHOTOGRAPHY",
                                    "TRADITIONAL VIDEOGRAPHY",
                                    "CANDID PHOTOGRAPHY",
                                    "CANDID VIDEOGRAPHY",
                                    "HELICAM",
                                    "MIXING UNIT",
                                    "LIVE STREAMING"
                                  ].map((serviceKey) =>
                                    ["teamShooterName", "serviceLevelStatus", "fileCount", "size", "remarks", "copiedDate"].map((field, index) => (
                                      <td
                                        key={`${serviceKey}-${field}-${index}`}
                                        style={{
                                          textAlign: "center",
                                          borderRight: "1px solid #e1e1e1",
                                          minWidth: "140px",
                                        }}
                                      >
                                        {/* Check if the service exists */}
                                        {data.serviceData[serviceKey]
                                          ? // Check if the field exists and has data
                                          field === "fileCount" && data.serviceData[serviceKey][field]?.length > 0
                                            ? data.serviceData[serviceKey][field].join(" / ")
                                            : field === "copiedDate" && data.serviceData[serviceKey][field]?.length > 0
                                              ? data.serviceData[serviceKey][field]
                                                .filter((date) => date) // Filter out invalid/null dates
                                                .map((date) => moment(date).format(dateFormate))
                                                .join(", ")
                                              : data.serviceData[serviceKey][field]?.length > 0
                                                ? data.serviceData[serviceKey][field].join(", ")
                                                : "--"
                                          : // Show placeholder for missing service
                                          "--"}
                                      </td>
                                    ))
                                  )}
                                </tr>
                              )
                            })
                          ) : (
                            <tr key={0}>
                              <td
                                className="text-align-center"
                                colSpan={17}
                              ></td>
                            </tr>
                          )}
                          <tr></tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  <Row>

                  </Row>
                </CardBody>
              </Card>
            </Col>
            {btnLoading ? (
              <Modal
                show={btnLoading}
                style={{ width: "6.8%", margin: "21% 50%" }}
              >
                <Modal.Body>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                    variant="success"
                    className="mx-2"
                    color="success"
                  />
                  {/* <span>Loading...</span> */}
                </Modal.Body>
              </Modal>
            ) : (
              ""
            )}
            {clientEventModal && (
              <Modal size="xl" show={clientEventModal}>
                <Modal.Header
                  style={{
                    backgroundColor: "#E40D8C",
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Event
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col md="12" lg="12" xl="12" className="mt-3">
                      <PaginationProvider
                        pagination={paginationFactory(clientOptions)}
                        keyField="index"
                        columns={clientColumns}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="index"
                            data={clientDataTable}
                            columns={clientColumns}
                            search
                            exportCSV
                          >
                            {(props) => (
                              <div>
                                <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                  <Row className="d-flex flex-row  ">
                                    <Col>
                                      <BootstrapTable
                                        {...props.baseProps}
                                        responsive
                                        striped={true}
                                        bordered={true}
                                        keyField="index"
                                        expandRow={clientExpandRow}
                                        columns={clientColumns}
                                        {...paginationTableProps}
                                      />
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{ marginTop: "5px" }}
                                    className="align-items-md-center mt-30"
                                  >
                                    <Col className="inner-custom-pagination d-flex">
                                      <div className="d-inline d-flex flex-row">
                                        <SizePerPageDropdownStandalone
                                          {...paginationProps}
                                        />
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            marginTop: "8px",
                                            marginLeft: "4px",
                                          }}
                                        >
                                          <PaginationTotalStandalone
                                            {...paginationProps}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className="text-md-right ms-auto"
                                        style={{ zIndex: 0 }}
                                      >
                                        <PaginationListStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </div>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={() => setClientEventModal(false)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

EventWiseDataCopy.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  paginationProps: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})
//EventWiseDataCopy
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EventWiseDataCopy)
)
